interface IMYDocumentStatus {
  _id?: string;
  id?: string;
  status: string;
  comment?: string;
  serialNumber: string;
  documentId: string;
  createdBy: string;
  timestamp: Date;
}

class MYDocumentStatusLog {
  id?: string;
  status: string;
  serialNumber: string;
  comment?: string;
  documentId: string;
  createdBy: {
    _id: string;
    email: string;
    name: string;
  } | string;
  timestamp: Date;

  constructor(documentStatusLogInfo: IMYDocumentStatus) {
    this.id = documentStatusLogInfo.id ?? documentStatusLogInfo._id;
    this.status = documentStatusLogInfo.status;
    this.comment = documentStatusLogInfo.comment;
    this.serialNumber = documentStatusLogInfo.serialNumber;
    this.documentId = documentStatusLogInfo.documentId;
    this.createdBy = documentStatusLogInfo.createdBy;
    this.timestamp = documentStatusLogInfo.timestamp;
  }

  fromDataModel(doc: any): MYDocumentStatusLog {
    doc.createdBy = doc.createdBy
      ? `${doc.createdBy.name ?? ""} (${doc.createdBy.email ?? ""})`
      : undefined;
    return new MYDocumentStatusLog(doc);
  }
}

export default MYDocumentStatusLog;
